<template>
    <sui-input fluid type="text" v-model="input" @input="onChange" />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            input: this.value,
        };
    },
    watch: {
        value: {
            handler(value) {
                this.input = value;
            },
            immediate: true,
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.input);
        }
    }
}
</script>
